import { createAction, props } from '@ngrx/store';

/**
 * Query-param snapshot for a single list view. Values mirror what Angular parses
 * from the URL (a string, or a comma-joined string for multi-value filters).
 */
export type ListFilterParams = Record<string, string | string[]>;

export const saveSnapshot = createAction(
  '[List Filters] Save Snapshot',
  props<{ routeKey: string; params: ListFilterParams }>()
);

export const clearSnapshot = createAction('[List Filters] Clear Snapshot', props<{ routeKey: string }>());
